/**
 * バージョンが指定バージョンかどうかを判定する
 * @param version - 判定したいバージョン文字列（nullやundefinedの場合は無条件でfalse）
 * @param detectVersion - 比較対象バージョン文字列
 * @returns バージョンが2.0の場合true、それ以外はfalse
 */
export function isVersion(version: string | null | undefined, detectVersion: string): boolean {
  if (!version) {
    return false;
  }
  return version === detectVersion;
}
